const LANG_KEY = "lang";

export function getLang() {
  try {
    return JSON.parse(localStorage.getItem(LANG_KEY));
  } catch (e) {
    return null;
  }
}

export function initPort(app) {
  app.ports.putLang &&
    app.ports.putLang.subscribe(function(x) {
      localStorage.setItem(LANG_KEY, JSON.stringify(x));
      app.ports.changeLang && app.ports.changeLang.send(x);
    });
}
